/* eslint-disable compat/compat */
class MegaMenuPanel extends window.BAO.CustomElement() {
  setupListeners () {
    super.setupListeners()

    this.els.trigger.elements.forEach(trigger =>
      this.listeners.add(trigger, 'click', this.onTriggerClick.bind(this)),
    )

    this.openCorrectGender()

    const checkPanelResize = new ResizeObserver(entries => {
      entries.forEach(entry => {
        let elHeight = '566px'
        if (
          [...entry.target.querySelectorAll('.hd-PanelCard')].map(
            el => el.offsetHeight,
          ).length === 0
        ) {
          return
        }

        elHeight = Math.max(
          ...[...entry.target.querySelectorAll('.hd-PanelCard')].map(
            el => el.offsetHeight,
          ),
        )

        entry.target
          .closest('.hd-Panel_Body')
          .style.setProperty('--js-max-height', `${elHeight}px`)
      })
    })

    // start observing for resize
    checkPanelResize.observe(this.els.body.element)

    this.els.trigger.elements.forEach(trigger =>
      this.listeners.add(
        trigger,
        'keydown',
        this.arrowKeyboardNavigation.bind(this),
      ),
    )
  }

  onTriggerClick (e) {
    const triggerIndex = Number(e.target.dataset.secondaryTriggerIndex)

    this.els.panel.elements.forEach((panel, index) => {
      if (index === triggerIndex) {
        this.openPanel(panel)
        e.target.setAttribute('aria-expanded', true)
      } else {
        this.closePanel(panel)
        this.els.trigger.elements.forEach((trigger, index) =>
          triggerIndex === index
            ? trigger.setAttribute('aria-expanded', true)
            : trigger.setAttribute('aria-expanded', false),
        )
      }
    })
  }

  closePanel (el) {
    el.setAttribute('aria-expanded', false)
    el.setAttribute('aria-hidden', true)
  }

  openPanel (el) {
    el.setAttribute('aria-expanded', true)
    el.setAttribute('aria-hidden', false)
  }

  arrowKeyboardNavigation (e) {
    if (e.key === 'ArrowDown') {
      e.preventDefault()
      if (
        this.els.trigger.elements.length !==
        Number(e.target.dataset.secondaryTriggerIndex) + 1
      ) {
        this.els.trigger.elements[
          Number(e.target.dataset.secondaryTriggerIndex) + 1
        ].focus()
      }
    }

    if (e.key === 'ArrowUp') {
      e.preventDefault()
      if (Number(e.target.dataset.secondaryTriggerIndex) !== 0) {
        this.els.trigger.elements[
          Number(e.target.dataset.secondaryTriggerIndex) - 1
        ].focus()
      }
    }
  }

  openCorrectGender () {
    if (sessionStorage.getItem('gender')) {
      const gender = sessionStorage.getItem('gender')

      this.els.trigger.elements.forEach(triggerEl => {
        if (triggerEl.dataset.title === 'men' && gender === 'male') {
          triggerEl.click()
        }

        if (triggerEl.dataset.title === 'women' && gender === 'female') {
          triggerEl.click()
        }
      })
    }
  }

  connectedCallback () {
    this.setupListeners()
  }
}

if (!customElements.get('mega-menu-panel')) {
  customElements.define('mega-menu-panel', MegaMenuPanel)
}
